const constants = {
  CALL_ONE: '81e6af55ddf0e8fd0321',
  CALL_TWO: '0e72bb920b7508b8ffc8',
  CHAT_ONE: '433ccc9d24a5b47f8d6d',
  CHAT_TWO: '59ac8bb5f7535d5b5f22',
  REMOTE_CUSTOMER_SERVICE_TWO: 'c260456b56fead9be60c',
  REMOTE_CUSTOMER_SERVICE_ONE: '74bc0f6c8a9ce4c2d61f',
  CODE_THIS_MONTH: '848d575d1428dcd62f70',
  CODE_LAST_MONTH: '2234766278d1a83641ed',
  CODE_NEXT_MONTH: 'bdfdf6270e89d71c5b6a',
  MENU_ONE_B2B: '確定売上・案件粗利金額',
  MENU_TWO_B2B: '見積売上・案件粗利金額',
  MENU_THREE_B2B: '見積売上・案件粗利金額',
  LINE_CHART_USER: '4b14aa6a2fed90e087dc',
  LINE_CHART_LENDER: '00c46ea2772de3747255',
  LINE_CHART_BORROWER: 'e9e54e2aaccca1c92ed2',
  PIE_CHART_BUSINESS: 'e9690f2f5b289c8b13bf',
  COL_CHART_DASHBOARD: '4a47ea36ebeedec3c667',
  PIE_CHART_DASHBOARD: '0c71305f5d171d923090',
  ACCEPT_ORDER: '19e423cd6c70ecc33e1c',
  CALENDAR: '2998726aeed6ff7750ef',
  AGG_PRODUCT_OP1: '契約 通信モバイル(ドコモ) オンラインショップ端末購入',
  AGG_PRODUCT_OP2: 'サービス 通信モバイル(ドコモ) Mydocomo契約変更',
  AGG_PRODUCT_OP3: '物販 イベント イベント会場限定品A販売',
  FORECAST_LINE_STAFF: '73805a509703c23cf44f',
  FORECAST_COL_SALE: '72a4264a59b60fe7d50b',
  FORECAST_PIE_SALE: 'a4bdfbddb0214e50b180',
  FORECAST_RADIANT_SALE: 'a4bdfbddb0214e50b180',
  EC_LINE_MEMBER: 'e290100ab91462d65093',
  EC_SALE_TREND: '95de7c1bb7de6dd54cc1',
  EC_ACCEPT_ORDER: 'a5472e37845dd32120b0',
  EC_REQUEST_ORDER: 'd9f270a618a8cd567e24',
  EC_TREND_ORDER: '9c5216f710f4763c9ee8',
  SPEC_ORDER: '7229985056ecd87c3b07',
  PAYMENT_AMOUNT: 0.77
}
export default constants

export const optionsAggProduct = [
  { AGG_PRODUCT_ID: '1', AGG_PRODUCT_OP: '契約 通信モバイル(ドコモ) オンラインショップ端末購入' },
  { AGG_PRODUCT_ID: '2', AGG_PRODUCT_OP: 'サービス 通信モバイル(ドコモ) Mydocomo契約変更' },
  { AGG_PRODUCT_ID: '3', AGG_PRODUCT_OP: '物販 イベント イベント会場限定品A販売' }
]

export const optionsSessionStatus = [
  { value: '高速&完結', label: '高速&完結' },
  { value: '低速&完結', label: '低速&完結' },
  { value: '遅延発生&完結', label: '遅延発生&完結' },
  { value: '再流入&完結', label: '再流入&完結' },
  { value: '途中切断', label: '途中切断' },
  { value: '切断', label: '切断' }
]

export const optionsServiceResults = [
  { value: 'キャンセル・見送り', label: 'キャンセル・見送り' },
  { value: '契約・購入拒否', label: '契約・購入拒否' },
  { value: '審査NG', label: '審査NG' },
  { value: '店舗・イベント送客完了', label: '店舗・イベント送客完了' },
  { value: '成約・購入完了', label: '成約・購入完了' },
  { value: '来店予約完了', label: '来店予約完了' },
  { value: '検討中(確度低)', label: '検討中(確度低)' },
  { value: '検討中(確度高)', label: '検討中(確度高)' }
]

export const optionsConSourceID = [
  { value: 'その他', label: 'その他' },
  { value: '出張販売先', label: '出張販売先' },
  { value: '依頼元店舗', label: '依頼元店舗' }
]

export const optionsTargetTxt = [
  { value: '未達', label: '未達' },
  { value: '達成', label: '達成' }
]

export const optionsCustomerAgeGroup = [
  { value: '10代', label: '10代' },
  { value: '20代', label: '20代' },
  { value: '30代', label: '30代' },
  { value: '40代', label: '40代' },
  { value: '50代', label: '50代' },
  { value: '60代', label: '60代' },
  { value: '70代以上', label: '70代以上' }
]

export const optionsCustomerSetai = [
  { value: '単身', label: '単身' },
  { value: '夫婦', label: '夫婦' },
  { value: '未成年者', label: '未成年者' },
  { value: '2世帯', label: '2世帯' }
]

export const optionsCustomerJob = [
  { value: '会社員', label: '会社員' },
  { value: '個人事業主', label: '個人事業主' },
  { value: '学生', label: '学生' }
]

export const optionsCustomerType = [
  { value: '主導型', label: '主導型' },
  { value: '感化型', label: '感化型' },
  { value: '安定型', label: '安定型' },
  { value: '慎重型', label: '慎重型' }
]

export const optionsServiceResultSt = [
  { value: '成約・購入完了', label: '成約・購入完了' },
  { value: '検討中(確度低)', label: '検討中(確度低)' },
  { value: '検討中(確度高)', label: '検討中(確度高)' },
  { value: '店舗・イベント送客完了', label: '店舗・イベント送客完了' },
  { value: '来店予約完了', label: '来店予約完了' },
  { value: 'キャンセル・見送り', label: 'キャンセル・見送り' }
]

export const DATE_FORMAT = 'YYYY-MM-DD'
export const TIMEJAPAN = 'Asia/Tokyo'
export const USER_TYPE = {
  employee: 'employee',
  staff: 'staff',
  test: 'test'
}

export const COLOR_EC = {
  default: '#E3FAE3',
  meeting: '#E3FAE3',
  deadline: '#E3FAE3'
}

export const TYPE_EVENT_CALENDAR = {
  meeting: 'meeting',
  deadline: 'deadline',
  default: 'default'
}

export const ROLE_USER = {
  all: 'all',
  staff: 'b2c-user',
  employee: 'b2b'
}

export const OPERATIONAL_STATUS = {
  NO: '案件終了',
  YES: '実施中'
}
